<script setup lang="ts">
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { NCard, NForm, NFormItem, NInput, NButton } from 'naive-ui'
import { login } from '../api'
import { message } from '../message'

const username = ref('admin')
const password = ref('')
const loading = ref(false)
const router = useRouter()

async function submit() {
  loading.value = true
  try {
    await login(username.value, password.value)
    message.success('Welcome back')
    router.push('/')
  } catch {
    message.error('Invalid credentials')
  } finally {
    loading.value = false
  }
}
</script>

<template>
  <div style="display: flex; justify-content: center; align-items: center; min-height: 100vh; background: #f5f6f7">
    <NCard style="width: 360px" title="Services Manager" :bordered="false">
      <NForm @submit.prevent="submit">
        <NFormItem label="Username">
          <NInput
            v-model:value="username"
            autocomplete="username"
            placeholder="admin"
          />
        </NFormItem>
        <NFormItem label="Password">
          <NInput
            v-model:value="password"
            type="password"
            autocomplete="current-password"
            placeholder="Enter password"
            @keyup.enter="submit"
          />
        </NFormItem>
        <NButton
          type="primary"
          :loading="loading"
          block
          attr-type="submit"
        >
          Sign in
        </NButton>
      </NForm>
    </NCard>
  </div>
</template>
